import { FC } from 'react';
import { Sparkle } from '../types/Sparkle';
import { useSocietyAiAgentPage } from '../context/SocietyAiAgentPageContext';

type NaviOrbProps = {
  size?: number;
  showSparkles?: boolean;
};

const SPARKLES: Sparkle[] = [
  { top: '10%', left: '26%', size: 4, delay: '0s' },
  { top: '18%', right: '22%', size: 3, delay: '0.6s' },
  { bottom: '18%', right: '26%', size: 4, delay: '1.2s' },
  { bottom: '22%', left: '20%', size: 3, delay: '1.7s' },
  { top: '48%', right: '8%', size: 3, delay: '2.2s' },
];

const NaviOrb: FC<NaviOrbProps> = ({ size = 56, showSparkles = true }) => {
  const { data } = useSocietyAiAgentPage();

  const bodySize = Math.round(size * 0.62);

  return (
    <div
      className="navi-orb"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <div
        className={`navi-orb__aura${
          data.isThinking ? ' navi-orb__aura--thinking' : ''
        }`}
      />
      <div
        className="navi-orb__body"
        style={{ width: bodySize, height: bodySize }}
      />
      {showSparkles &&
        SPARKLES.map((s, i) => (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className="navi-orb__sparkle"
            style={{
              width: s.size,
              height: s.size,
              top: s.top,
              bottom: s.bottom,
              left: s.left,
              right: s.right,
              animationDelay: s.delay,
            }}
          />
        ))}
    </div>
  );
};

export default NaviOrb;
